import Axios from '@/axios';

// 查询黑名单人员
export const getBlackList = params => {  
  return Axios({
    url: '/face/web/black_list_person/index_black_list_person',
    method: 'GET',
    type: 'json',
    params
  })
}
// 新增黑名单人员
export const createBlack = data => {  
  return Axios({
    url: '/face/web/black_list_person/create_black_list_person',
    method: 'POST',
    type: 'json',
    data
  })
}
// 修改黑名单人员
export const modifyBlack = data => {  
  return Axios({
    url: '/face/web/black_list_person/update_black_list_person/' + data.id,
    method: 'POST',
    type: 'json',
    data
  })
}
// 删除黑名单人员
export const deleteBlack = data => {  
  return Axios({
    url: '/face/web/black_list_person/delete_black_list_person/' + data.id,
    method: 'POST',
    type: 'json',
    data
  })
}